export default "__VITE_ASSET__Bfyjrs1d__"